const degrees = [
  {
    school: 'University of Washington',
    degree: 'M.S. Information Management',
    year: '2019 - 2021',
  },
  {
    school: 'China Agricultural University ',
    degree: 'B.S. Agricultural Economics',
    year: '2013 - 2017',
  },
];

export default degrees;
